export default __webpack_public_path__ + "static/media/image-chair-learn-w@2x.83b98cbd.png";